import Backend from "shared/lib/Backend";
import { v4 as uuid } from 'uuid';

export default props => async dispatch => {
  const id = uuid();

  dispatch({
    type: "COLLECTIONS/ENTITY/ADD",
    payload: { id, entity: props.data }
  });

  const body = JSON.stringify({ entity: props, temporary_id: id });
  const response = await Backend.requestJson(
    `${window.location.pathname}/collections`,
    { body },
    "POST"
  );

  dispatch({
    type: "COLLECTIONS/ENTITY/SAVED",
    payload: { id: response.temporary_id, entity: response.entity }
  });
};
